import { createAnalyticsClient as l } from "../../analytics.js";
import { createWebHistoryRouter as s } from "../../router.js";
import n from "./ApiClientApp.vue.js";
import "./ApiClientApp.vue2.js";
import { saveActiveWorkspace as f } from "../../routes.js";
import { createApiClient as y } from "../../libs/create-client.js";
const h = l(), x = async (p, t = {}, a = !0, e = s()) => {
  const r = y({
    el: p,
    appComponent: n,
    configuration: t,
    mountOnInitialize: a,
    router: e,
    layout: "desktop"
  }), { importSpecFile: m, importSpecFromUrl: c } = r.store;
  return e.afterEach((o, i) => {
    h.capture("page-view", {
      hostname: window.location.hostname,
      to: o.path,
      // capture path excluding query params
      from: i.path
    }), f(o);
  }), t.url ? await c(t.url, "default", {
    proxyUrl: t.proxyUrl
  }) : t.content && await m(t.content, "default"), r;
};
export {
  h as analytics,
  x as createApiClientApp
};
